module.exports = __webpack_public_path__ + "static/media/Setting.a1908397.svg";